// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax, mediaMin } from 'components/styles/_media'
import TopicItemCard, {
  type PropTypes as TopicItemCardTypes,
} from 'components/molecules/TopicListItem'
import Colors from 'components/styles/colors'
import type { Topic } from 'types/www/topic'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { imageURLWithTransform } from 'frontend_core/dist/helpers/format'

type PropTypes = {
  title: string,
  content: string,
  image: string,
  linkUrl: string,
  priceText: string,
  capacity: string,
  area: string,
}

export default (props: PropTypes) => {
  const imageUrl = imageURLWithTransform(props.image, {
    width: 670,
    height: 400,
    crop: 'fill',
  })
  return (
    <li className="mediumlist-space__item">
      <a href={props.linkUrl}>
        <p className="mediumlist-space__img center-img">
          <OptimizedImage src={imageUrl} alt={props.title} />
        </p>
        <div className="mediumlist-space__detail">
          <p className="mediumlist-space__spacename">{props.title}</p>
          <p className="mediumlist-space__text">{props.content}</p>
          <div className="mediumlist-space__info">
            <p className="mediumlist-space__price">{props.priceText}</p>
            <ul className="space-head__list link__subcolor">
              <li className="space-head__list-user">
                <i className="fa fa-user mr5" />
                {props.capacity}
              </li>
              <li className="space-head__list-map">
                <i className="fa fa-map-marker mr5" />
                {props.area}
              </li>
            </ul>
          </div>
        </div>
      </a>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/TopicContentItem/ThreeColumnSpace/index.jsx